<template>
  <b-modal
    id="statusModal"
    centered
    hide-footer
    hide-header
    hide-actions
    no-close-on-backdrop>
    <section class="c-modal c-modal--dark c-modal--status">
      <div
        class="c-modal__dialog"
      >
        <div class="d-flex justify-content-end p-3">
          <button
            @click="$bvModal.hide('statusModal')"
            class="c-link c-link--gray">
            <i class="iconf-cancel fs-21"></i>
          </button>
        </div>
        <section
          class="p-4">
          <div class="text-center">
            <figure class="mb-3">
              <img
                src="@/assets/images/lection/homework/no-completed.png"
                class="w-100 h-100 of--contain"
                alt="Master Class - Razones para migrar de Autocad a Revit"
              />
            </figure>
            <p class="mb-0">
              Hola, te pedimos mil disculpas por interrumpir tu experiencia en Arcux pero
              estamos sufriendo problemas con nuestro proveedor de videos. Actualmente
              <span class="w-bold">todo el equipo</span> esta trabajando
              en solucionar el problema. Volveremos pronto!
            </p>
          </div>
        </section>
      </div>
    </section>
  </b-modal>
</template>

<script>
export default {
  mounted() {
    if (process.env.VUE_APP_STATUS_MODAL === '1') {
      this.$bvModal.show('statusModal');
    }
  },
};
</script>
